export { RecentlyViewedProductsDocument } from "./generated/graphql";
export * from "./components";
export * from "./consts";
export * from "./utilities";
export { useRecentlyViewedProducts, recordProductView } from "./hooks/useRecentlyViewedProducts/useRecentlyViewedProducts"; // Mock handlers

export * from "./mocks/handlers/mockRecommendedProducts";
export { handler as coPurchasedRecommenderHandler } from "./mocks/handlers/CoPurchasedRecommender/CoPurchasedRecommender.query";
export { handler as recentlyViewedProductsQueryHandler } from "./mocks/handlers/RecentlyViewedProducts/RecentlyViewedProducts.query";
export { handler as recommendedEventsQueryHandler } from "./mocks/handlers/RecommendedEvents/RecommendedEvents.query";